import { Form, InputNumber } from 'antd';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { TextWithInput } from 'app/components/commons/TextWithInput/TextWithInput';
import type { ExtranetPackage } from 'app/typings/packages';

import { SwitchableInput } from '../../../../../commons/SwitchableInput/SwitchableInput';
import type { ExtraGuestDetail, PackageToggleSwitchParam } from '../Utils';
import { generatePackageSetIsSwitchOn, isSwitchOn } from '../Utils';

import { PriceReminder } from './PriceReminder/PriceReminder';

const RULES = [{ required: true, message: 'Required' }];

type ConfigurationProps = {
  taskInformation: ExtraGuestDetail;
  packages: ExtranetPackage[];
  toggleSwitches: PackageToggleSwitchParam[];
  setToggleSwitches: (toggleSwitches: PackageToggleSwitchParam[]) => void;
};

export const Configuration = ({
  taskInformation,
  packages,
  toggleSwitches,
  setToggleSwitches,
}: ConfigurationProps) => {
  const { currencySymbol } = useContext(CurrencyContext);

  const filteredPackages = packages.filter(
    (pkg) =>
      taskInformation.valueName !== 'additionalChildPrice' ||
      pkg.childrenAllowed
  );

  return (
    <div className="body-section">
      <div className="body-section__title-container">
        <h1>{taskInformation.priceConfiguration.title}</h1>
        <p className="body-section__subtitle">
          {taskInformation.priceConfiguration.section.information}
        </p>
      </div>
      <>
        {filteredPackages.map((pkg) => (
          <SwitchableInput
            name={pkg.aliasForHotel}
            key={pkg.id}
            value={isSwitchOn(pkg.id, toggleSwitches)}
            onChange={generatePackageSetIsSwitchOn(
              pkg.id,
              toggleSwitches,
              setToggleSwitches
            )}
            childNode={
              <div className="body-section__input-container">
                <PriceReminder pkg={pkg} />
                <TextWithInput
                  beforeText={
                    taskInformation.priceConfiguration.section.price.firstPart
                  }
                  afterText={
                    taskInformation.priceConfiguration.section.price.secondPart
                  }
                  inputField={
                    <Form.Item name={pkg.id} rules={RULES}>
                      <InputNumber
                        addonAfter={currencySymbol}
                        min={0}
                        onWheel={(e) => e.currentTarget.blur()}
                        disabled={!isSwitchOn(pkg.id, toggleSwitches)}
                      />
                    </Form.Item>
                  }
                />
              </div>
            }
          />
        ))}
      </>
    </div>
  );
};
